import styled from 'styled-components';
import Wra16D from 'dc/Wra16D';
import Act24 from 'dc/Act24';

type WrapperProps = {
  $expanded: boolean;
};

export const Wrapper = styled(Wra16D)<WrapperProps>`
  background-color: ${props => (props.$expanded ? '#ffffff' : '#f4f7f9')};
  width: 100%;
  height: 52px;
  position: relative;
  z-index: 1;
`;
type ActivityIconProps = {
  $position: number;
};

export const ActivityIcon = styled(Act24)<ActivityIconProps>`
  display: inline;
  position: absolute;
  left: ${props => `${props.$position}px`};
`;
